import React from 'react';
import { Info, Ruler } from 'lucide-react';
import { useFormContext } from '../FormContext';
import { FormStep } from '../FormStep';
import { InfoBox } from '../InfoBox';
import { FormButtons } from '../FormButtons';
export const ZandcementDetailsStep: React.FC = () => {
  const {
    formData,
    handleChange,
    goToPreviousStep,
    goToNextStep
  } = useFormContext();
  return <FormStep title="Zandcement vloer details" description="Geef de afmetingen van de gewenste zandcement vloer aan." isActive={true} data-id="element-1281">
      <div className="space-y-6 mb-10" data-id="element-1282">
        <div data-id="element-1283">
          <label className="block text-white/90 font-medium mb-2" data-id="element-1284">
            Lengte (cm) *
          </label>
          <div className="relative" data-id="element-1285">
            <input type="text" inputMode="numeric" value={formData.zandcementLength} onChange={handleChange} name="zandcementLength" placeholder="Bijv. 500" className="w-full px-4 py-3 rounded-md border border-white/30 bg-white/10 focus:outline-none focus:ring-2 focus:ring-[#CDA735] focus:border-transparent text-white placeholder-white/50" data-id="element-1286" />
            <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none" data-id="element-1287">
              <Ruler className="h-5 w-5 text-white/50" data-id="element-1288" />
            </div>
          </div>
        </div>
        <div data-id="element-1289">
          <label className="block text-white/90 font-medium mb-2" data-id="element-1290">
            Breedte (cm) *
          </label>
          <div className="relative" data-id="element-1291">
            <input type="text" inputMode="numeric" value={formData.zandcementWidth} onChange={handleChange} name="zandcementWidth" placeholder="Bijv. 300" className="w-full px-4 py-3 rounded-md border border-white/30 bg-white/10 focus:outline-none focus:ring-2 focus:ring-[#CDA735] focus:border-transparent text-white placeholder-white/50" data-id="element-1292" />
            <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none" data-id="element-1293">
              <Ruler className="h-5 w-5 text-white/50" data-id="element-1294" />
            </div>
          </div>
        </div>
        <div data-id="element-1295">
          <label className="block text-white/90 font-medium mb-2" data-id="element-1296">
            Extra opmerkingen (optioneel)
          </label>
          <textarea value={formData.zandcementRemarks} onChange={handleChange} name="zandcementRemarks" rows={3} placeholder="Bijv. afwerking, speciale wensen, etc." className="w-full px-4 py-3 rounded-md border border-white/30 bg-white/10 focus:outline-none focus:ring-2 focus:ring-[#CDA735] focus:border-transparent text-white placeholder-white/50" data-id="element-1297" />
        </div>
      </div>
      <InfoBox icon={<Info data-id="element-1299" />} data-id="element-1298">
        Verdere details over afwerking, dikte en toepassing zullen telefonisch
        met u worden besproken.
      </InfoBox>
      <FormButtons onPrevious={goToPreviousStep} onNext={goToNextStep} isNextDisabled={!formData.zandcementLength || !formData.zandcementWidth} data-id="element-1300" />
    </FormStep>;
};